import { Button } from '@vrplatform/components';
import { LoadingIndicator } from '@vrplatform/components-legacy';
import { isStaging, useTrackingSignOut } from '@vrplatform/data';
import { Center } from '@mantine/core';

type FullPageLoadingIndicatorProps = {
  message?: string;
  showSignOut?: boolean;
};

export const FullPageLoadingIndicator = ({
  message,
  showSignOut = true,
}: FullPageLoadingIndicatorProps) => {
  return (
    <Center sx={{ height: '100vh', flexDirection: 'column' }}>
      <LoadingIndicator isFullPageLoading message={message} size="md" />
      {showSignOut && (
        <>
          <Signout />

          {isStaging && (
            <Button
              color="primary"
              variant="transparent"
              component="a"
              sx={{ marginTop: '1rem' }}
              href="https://portal.vrplatform.app?vrp_staging_overwrite=true"
            >
              Redirect to production
            </Button>
          )}
        </>
      )}
    </Center>
  );
};

const Signout = () => {
  const signOut = useTrackingSignOut();

  return (
    <Button
      variant="transparent"
      onClick={() => signOut({ trackEvent: false })}
    >
      Sign out
    </Button>
  );
};
